import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Label } from "../ui/label";

interface EnumOption {
  value: number;
  label: string;
}

interface EnumSelectProps {
  label: string;
  value: number;
  options: EnumOption[];
  onChange: (value: number) => void;
  className?: string;
}

function getEnumLabel(value: number, options: EnumOption[]): string {
  const option = options.find((o) => o.value === value);
  return option?.label ?? `Unknown (${value})`;
}

export function EnumSelect({ label, value, options, onChange, className }: EnumSelectProps) {
  return (
    <div className={className}>
      <Label className="mb-1.5 block text-xs text-overlay1">{label}</Label>
      <Select
        value={String(value)}
        onValueChange={(v) => onChange(Number(v))}
      >
        <SelectTrigger>
          <SelectValue>{getEnumLabel(value, options)}</SelectValue>
        </SelectTrigger>
        <SelectContent>
          {options.map((opt) => (
            <SelectItem key={opt.value} value={String(opt.value)}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
